// extracted by mini-css-extract-plugin
export default {"dragNDropIconContainer":"suspend-activity-styles_dragNDropIconContainer__7CqqT","badgeCustom":"suspend-activity-styles_badgeCustom__UyCSA"};